import { render, staticRenderFns } from "./MinMaxInputs.vue?vue&type=template&id=9924c46c&"
import script from "./MinMaxInputs.vue?vue&type=script&lang=js&"
export * from "./MinMaxInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports